<template>
  <div>
    <ShoppingListCartElement
      @change="handleChange"
      v-for="item in elements"
      :key="item.Id"
      :item="item"
    />
    <div class="actions m-t-20">
      <SfButton @click="moveToCart(cart.Id)">
        {{ $t('Move to Cart') }}
      </SfButton>
      <SfButton @click="remove(cart.Id)" class="m-t-10 sf-button--text">
        {{ $t('Remove List') }}
      </SfButton>
    </div>
  </div>
</template>

<script>
import { SfButton } from '@storefront-ui/vue';
import user from '../mixins/user';
import ShoppingListCartElement from './ShoppingListCartElement.vue';

export default {
  name: 'ShoppingListCart',
  mixins: [user],
  components: {
    SfButton,
    ShoppingListCartElement,
  },
  props: {
    cart: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      open: 'Clothing',
      multiple: true,
      showChevron: true,
      transition: 'sf-expand',
      elements: this.cart.Items.map((item, index) => ({
        ...item,
        index,
        selected: false,
      })),
    };
  },
  methods: {
    handleChange(newItem) {
      this.elements.splice(newItem.index, 1, {
        ...newItem,
        selected: !newItem.selected,
      });
    },
    remove(id) {
      this.deleteShoppingList(id).then(() => {
        this.fetchShoppingList();
      });
    },
    moveToCart(id) {
      const selectedItems = this.elements.reduce(
        (acc, curr) => (curr.selected ? [...acc, curr.Sku] : acc),
        [],
      );
      const payload = {
        Sku: selectedItems.length ? selectedItems : this.elements.map(({ Sku }) => Sku),
      };
      this.creteCartFromShoppingList({ id, payload })
        .then(() => {
          this.$router.push('/cart');
        });
    },
  },
};
</script>
